import React, { Component } from 'react'
import {
    createStyles, WithStyles, withStyles, Theme, Dialog,
    DialogTitle, Typography, DialogContent, FormGroup,
    FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Button
} from '@material-ui/core'
import { connect } from 'react-redux'
import { Dispatch } from 'redux';
import { ONewLTDDocument } from '../Features/AddNewLTDDocument/redux-config';
import _ from 'lodash';

interface IStateProps {
    open: boolean
    formData: Record<string, any>
    appConstants: any
}

interface IDispatchProps {
    setFormValue?: (key: string, value: string) => void
    closeDialog?: () => void
    openEditDialog?: () => void
}

interface IState { }

interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps { }

class NewLTDDocument extends Component<IProps, IState> {

    onSubmit = (e: any) => {
        if (_.isEmpty(this.props.formData['contentType']))
            return;
        this.openEditDialog();
        this.closeDialog();
    }

    handleChange = (e: React.ChangeEvent<{}>, value: string) => {
        if (this.props.setFormValue)
            this.props.setFormValue('contentType', value);
    }

    closeDialog = () => {
        if (this.props.closeDialog)
            this.props.closeDialog();
    }



    openEditDialog = () => {
        if (this.props.openEditDialog)
            this.props.openEditDialog();
    }

    render() {
        const { classes, open, formData = {} } = this.props;
        const key = 'contentType';

        return (
            <Dialog
                scroll="body"
                open={open || false}
                PaperProps={{ className: classes.paper }}
            >
                <div className={classes.title} >
                    <Typography variant="h6">
                        New Document
                    </Typography>
                    <Button onClick={this.closeDialog}>
                        <i className="material-icons">close</i>
                    </Button>
                </div>
                <div className={classes.content}>
                    <Typography variant="h6">Select document type</Typography>
                    <FormControl className={classes.formControl}>
                        <RadioGroup aria-label="contentType" name={key} value={formData[key] || ''} onChange={this.handleChange}>
                            {
                                (_.get(this.props.appConstants, 'contentType') || []).map(type => (
                                    <FormControlLabel key={type.value} value={type.value} control={<Radio color="primary" />} label={type.name} />
                                ))
                            }
                        </RadioGroup>
                    </FormControl>
                    <Button fullWidth className={classes.submitButton} color="primary" onClick={this.onSubmit} variant="contained">submit</Button>
                </div>
            </Dialog>
        )
    }
}

const mapStateToProps = (state): IStateProps => ({
    open: _.get(state, 'NewLTDDocument.documentTypeSelectionDialog'),
    formData: _.get(state, 'NewLTDDocument.formData'),
    appConstants: _.get(state.App, 'appConstants.LtdDoc')
})

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => ({
    setFormValue: (key: string, value: string) => dispatch(ONewLTDDocument.setFormField(key, value)),
    closeDialog: () => dispatch(ONewLTDDocument.closeDocumentSelectionDialog()),
    openEditDialog: () => dispatch(ONewLTDDocument.openDialog()),
})

const STYLES = (theme: Theme) => createStyles({
    paper: {
        width: 400,
        maxWidth: 400
    },
    content: {
        padding: 24,
        '& button': {
            marginTop: 28,
            color: theme.palette.common.white
        }
    },
    title: {
        background: theme.palette.common.black,
        padding: '12px 24px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        '& h6': {
            color: theme.palette.common.white
        },
        '& i': {
            color: theme.palette.common.white
        },
        '& button': {
            minWidth: 0,
            minHeight: 0,
            height: 30,
            width: 30
        }
    },
    formControl: {

    },
    submitButton: {

    }
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(NewLTDDocument))